import isEmpty from 'lodash/isEmpty';

const buildBillingDetailsQueryParams = (billingDetails?: BillingDetail) => {
  if (isEmpty(billingDetails)) {
    return '';
  }

  const {
    email,
    mobilePhone,
    firstName,
    lastName,
    streetNumber,
    streetName,
    city,
    zipCode,
    stateOrDistrict,
    countryCode,
  } = billingDetails;
  return `billingDetails: {
    ${email ? `email: "${email}"` : ''}
    ${mobilePhone ? `mobile_phone: "${mobilePhone}"` : ''}
    first_name: "${firstName || ''}",
    last_name: "${lastName || ''}",
    address1: "${streetNumber || ''} ${streetName || ''}",
    locality: "${city || ''}",
    postal_code: "${zipCode || ''}",
    administrative_area: "${stateOrDistrict || ''}",
    country_code: "${countryCode || ''}",
  }`;
};

function paymentRedirectMutation(params: PaymentRedirectBookingParams) {
  const paymentConditionId = params.paymentConditionId
    ? `paymentConditionId: "${params.paymentConditionId}"`
    : '';
  const token = params.token ? `token: "${params.token}"` : '';
  const browserInfo = params.browserInfo ? `browserInfo: "${params.browserInfo}"` : '';
  const donationAmount = params.donationAmount ? `donationAmount: ${params.donationAmount}` : '';
  const billingDetails = buildBillingDetailsQueryParams(params.billingDetails);
  const callReference = params.callReference ? `callReference: "${params?.callReference}"` : '';
  const contactID = params.contactID ? `contactID: "${params?.contactID}"` : '';
  const customerId = params.customerId ? `customerId: "${params?.customerId}"` : '';
  const device = params.device ? `device: "${params.device}"` : '';
  const bookingId = params.bookingId ? `bookingId: "${params?.bookingId}"` : '';
  const proposalId = params.proposalId ? `proposalId: "${params?.proposalId}"` : '';
  const comments = params.comments ? `comments: "${params?.comments}"` : '';
  const salesmanCode = params.salesmanCode ? `salesmanCode: "${params.salesmanCode}"` : '';
  const salesNetworkId = params.salesNetworkId ? `salesNetworkId: "${params.salesNetworkId}"` : '';
  const cxoOpportunityGuid = params.cxoOpportunityGuid
    ? `cxoOpportunityGuid: "${params.cxoOpportunityGuid}"`
    : '';
  return `
    mutation {
      paymentRedirect(
        callbackUrl: "${params.callbackUrl}"
        callbackUrlSeller: "${params.callbackUrlSeller}"
        cancelUrl: "${params.cancelUrl}"
        currency: "${params.currency}"
        iframeCallbackUrl: "${params.iframeCallbackUrl}"
        isIframePayment: ${(params.isIframe || false).toString()}
        price: ${params.price}
        providerId: "${params.providerId}"
        action: "${params.action}"
        shouldSkipPayment: ${String(!!params.shouldSkipPayment)}
        ${device}
        ${donationAmount}
        ${browserInfo}
        ${paymentConditionId}
        ${proposalId}
        ${token}
        ${billingDetails}
        ${callReference}
        ${contactID}
        ${customerId}
        ${comments}
        ${bookingId}
        ${salesmanCode}
        ${salesNetworkId}
        ${cxoOpportunityGuid}
      ) {
          method
          url
          fields
          bookingId
          orderId
          customerId
          price {
            value
          }
          donationAmount
        }
      }`;
}

export { paymentRedirectMutation };
